import { Link } from 'react-router-dom';
import VisibilityIndicator from '../../atoms/VisibilityIndicator/VisibilityIndicator';
import './GiftListSummary.scss';
import { Visibility } from '../../../services/GiftsApi';
import InfoBox from '../../atoms/InfoBox/InfoBox';

interface GiftListSummaryProps {
    id: number;
    name: string;
    giftCount: number;
    visibility: Visibility;
    editorCount?: number;
}

const GiftListSummary = (props: GiftListSummaryProps) => {
    let className = 'list-summary-container list-summary-container-' + props.visibility;
    return (
        <Link to={"/lists/" + props.id} className="list-summary-link">
            <div className={className}>
                <p className="list-summary-header">
                    <span className="list-summary-name">
                        {props.name}
                    </span>
                    <span className="list-summary-count">({props.giftCount} gift{props.giftCount === 1 ? '' : 's'})</span>
                </p>
                {props.visibility && <p className="list-summary-visibility-indicator">
                    <VisibilityIndicator visibility={props.visibility} />
                </p>}
                <div className="list-summary-end"></div>
                {props.editorCount && props.editorCount > 1 &&
                    <InfoBox message={`This list is maintained by ${props.editorCount} ${props.editorCount === 1 ? 'person' : 'people'}`} />
                }
            </div>
        </Link>
    );
}

export default GiftListSummary;